/* eslint-disable */
export default {
  loading: '読み込み中...',
} as const;

// @key: @#@"loading"@#@ @source: @#@"Loading ..."@#@
